/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreateBrokerSwapRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class BrokerSwap<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name CreateBrokerSwap
   * @request POST:/brokerSwap
   * @secure
   */
  createBrokerSwap = (data: CreateBrokerSwapRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/brokerSwap`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsBrokerSwap
   * @request OPTIONS:/brokerSwap
   */
  optionsBrokerSwap = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/brokerSwap`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsBrokerSwap2
   * @request OPTIONS:/brokerSwap/{id}
   * @originalName optionsBrokerSwap
   * @duplicate
   */
  optionsBrokerSwap2 = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/brokerSwap/${id}`,
      method: 'OPTIONS',
      ...params,
    });
}
